import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { DialogBase } from 't4core';
import { ServiceRequestStatus } from '../../../../../dist/t4core';

@Component({
    selector: 't4-IssueNoteDialog',
    templateUrl: 'IssueNoteDialog.html',
})
export class IssueNoteDialog extends DialogBase implements OnInit {
    public ctrlNewEstimatedDate = new FormControl();
    public ctrlComment = new FormControl();
    public activateObject: boolean = true;


    public enableTags: boolean = false;
    public selectedTags: string;

    public get notes(): string {
        return this.ctrlComment.value;
    }

    public get newEstimatedDate(): moment.Moment {
        return this.ctrlNewEstimatedDate.value;
    }

    constructor(public dialogRef: MatDialogRef<IssueNoteDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("IssueNoteDialog");

        if (data.enableEstimate) this.ctrlNewEstimatedDate.enable();
        else this.ctrlNewEstimatedDate.disable();

        if (data.estimatedDate) this.ctrlNewEstimatedDate.setValue(data.estimatedDate);

      if (data.updateText) this.ctrlComment.setValue(data.updateText);

      if (data.isInsurance && data.status == ServiceRequestStatus.Completed && this.Settings.isInAny(['BackOffice'])) this.enableTags = true;

    }

  ngOnInit(): void {
    }

    public save() {
        if (!this.newEstimatedDate || this.newEstimatedDate < this.today) {
            this.UI.alert("Turbo.OneWayAdmin.ServiceDialog.msgInvalidEstimate.Headline", "Invalid estimated resolve date", "Turbo.OneWayAdmin.ServiceDialog.msgInvalidEstimate.Message", "You have to specify an estimate of when this action will be completed.");
            return;
      }

      this.dialogRef.close({ newEstimate: this.newEstimatedDate, notes: this.notes, enableObject: this.activateObject, insuranceTags: this.selectedTags });
    }
}
